"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _input = _interopRequireDefault(require("../../../core/input"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _submit = _interopRequireDefault(require("../../../core/submit"));
var _container = _interopRequireDefault(require("../../../core/container"));
var _existingUserCheck = _interopRequireDefault(require("../../../core/existing-user-check"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  usersToMerge: {
    oldEmail: null,
    newEmail: null
  },
  oldEmail: null,
  isSubmitting: false,
  message: false,
  isSuccess: false
};
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, "This section allows for movement of entries from one email address to another. It is important to make sure that the request to do so is coming from a validated source.");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Expired User Email");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "New User Email");
var _ref4 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-danger"
}, "Invalid Email.");
class UserMerge extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_setValue", (value, name) => {
      if (name === 'oldEmail') {
        this.setState({
          oldEmail: value
        });
        clearTimeout(this._oldEmailDebounce);
        this._oldEmailDebounce = setTimeout(() => {
          this.setState({
            usersToMerge: {
              ...this.state.usersToMerge,
              [name]: value
            }
          });
        }, 600);
        return;
      }
      this.setState({
        usersToMerge: {
          ...this.state.usersToMerge,
          [name]: value
        }
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      if (!this.state.usersToMerge.oldEmail || !this.state.usersToMerge.newEmail) return;
      this.setState({
        isSubmitting: true
      });
      this.props.onMergeUsers(this.state.usersToMerge).then(result => {
        this.setState({
          message: result.message,
          isSubmitting: false,
          isSuccess: result.isSuccess
        });
      }, err => {
        this.setState({
          message: err.message,
          isSubmitting: false,
          isSuccess: false
        });
      });
    });
    _defineProperty(this, "_onCancel", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_onMessageDismissed", () => {
      if (this.state.isSuccess) {
        this.setState(initialState);
      } else {
        this.setState({
          message: null
        });
      }
    });
  }
  render() {
    const dismissMessageButton = /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onMessageDismissed
    }, "OK");
    return /*#__PURE__*/_react.default.createElement(_container.default, null, !this.state.message ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: dismissMessageButton,
      onClose: this.props.onMessageDismissed
    }, /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: this.state.isSuccess ? 'success' : 'danger'
    }, this.state.message)), _ref, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        xs: 12,
        sm: 3,
        md: 3
      }, {
        xs: 5,
        sm: 4,
        md: 4
      }, {
        xs: 7,
        sm: 5,
        md: 5
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "email",
      name: "oldEmail",
      value: this.state.oldEmail,
      onChange: this._setValue,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_existingUserCheck.default, {
      userEmail: this.state.usersToMerge.oldEmail
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "email",
      name: "newEmail",
      value: this.state.usersToMerge.newEmail,
      onChange: this._setValue,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_col.default, null, !this.state.usersToMerge.newEmail || /^.+\@.+\.[^.]+$/.test(this.state.usersToMerge.newEmail) ? null : _ref4))), !this.state.usersToMerge.oldEmail || this.state.usersToMerge.newEmail ? null : /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "warning"
    }, "This will move all the entries and payments from user ", this.state.usersToMerge.oldEmail, " to", ' ', this.state.usersToMerge.newEmail, ". Are you sure that you want to continue?"), !this.state.usersToMerge.newEmail ? null : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.isSubmitting
    }, "Confirm Merge"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancel
    }, "Cancel Merge"))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(UserMerge, undefined, (client, props) => ({
  onMergeUsers(usersToMerge) {
    return client.update('User.mergeUsers', usersToMerge);
  }
}));